import React from "react";

export default class delegation extends React.Component {

}